import React from "react";
import { Icon } from "@/components/Icon";
import { cn } from "@/lib/utils";

/* SegmentedPills — the category / filter pill row (PREMIUM_UI_DIRECTION §4.5).

   Deliberately WHITE-selected (bg-white text-surface-1), NOT green: category selection must
   not compete with the one meaningful green on the screen (the play-wallet selector / primary
   CTA). Horizontal-scroll row that hides its scrollbar.

   Props:
   - items: [{ id, label, icon? }]
   - value: selected id
   - onChange(id)
   - size: "md" (default, h-10) | "sm" (h-9)
   - testidPrefix (default "pill"): each pill is `${testidPrefix}-${id}`
   - className */
export default function SegmentedPills({
  items = [],
  value,
  onChange,
  size = "md",
  testidPrefix = "pill",
  className,
  ariaLabel = "Filter",
}) {
  const h = size === "sm" ? "h-9" : "h-10";
  return (
    <div
      className={cn("no-scrollbar flex gap-2 overflow-x-auto", className)}
      role="tablist"
      aria-label={ariaLabel}
    >
      {items.map((it) => {
        const on = value === it.id;
        return (
          <button
            key={it.id}
            type="button"
            role="tab"
            aria-selected={on}
            data-testid={`${testidPrefix}-${it.id}`}
            onClick={() => onChange && onChange(it.id)}
            className={cn(
              "inline-flex shrink-0 items-center gap-2 rounded-full border px-4 text-sm font-bold transition-colors duration-[var(--dur-base)] focus-ring",
              h,
              on
                ? "border-transparent bg-white text-surface-1"
                : "border-surface-border bg-surface-3 text-meta hover:text-white"
            )}
          >
            {it.icon && <Icon name={it.icon} size={15} />}
            {it.label}
          </button>
        );
      })}
    </div>
  );
}
